/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment } from '@wordpress/element';
import { BlockControls, AlignmentControl, InspectorControls } from '@wordpress/block-editor';
import ServerSideRender from '@wordpress/server-side-render';
import { PanelBody, SelectControl, RangeControl } from '@wordpress/components';

export default function Edit( props ) {
	const { setAttributes, attributes } = props;
	const { textAlign, listGap, listStyle } = attributes;
	
	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<BlockControls>
					<AlignmentControl
						value={textAlign}
						onChange={(nextAlign) => {
							setAttributes({ textAlign: nextAlign });
						}}
					/>
				</BlockControls>
				<InspectorControls>
					<PanelBody title={ __( 'Trip Enquiry Options' ) } >	
						<SelectControl
							label={__('List Style', 'wp-travel-blocks')}
							value={ listStyle }
							options={ [
								{
									label: __('None', 'wp-travel-blocks'),
									value:'none'
								},{
									label: __('Disc', 'wp-travel-blocks'),
									value:'disc'
								},{
									label: __('Check Icon', 'wp-travel-blocks'),
									value:'check-icon'
								},{
									label: __('Square', 'wp-travel-blocks'),
									value:'square'
								},{
									label: __('Decimal', 'wp-travel-blocks'),
									value:'decimal'
								},{
									label: __('Roman', 'wp-travel-blocks'),
									value:'upper-roman'
								}
							] }
							onChange={ (val) => setAttributes( { listStyle: val } ) }
						/>
						<RangeControl
							label={__('List Gap', 'wp-travel-blocks')}
							onChange={ (value) => setAttributes( { listGap: value } ) }
							shiftStep={ 1 }
							min={ 2 }
							max={ 100 }
							value={ listGap }
						/>
					
					</PanelBody>
				</InspectorControls>
			</Fragment>
			<ServerSideRender
				block="wp-travel-blocks/trip-includes"
				attributes={ props.attributes }
			/>
		</div>
	);
}
